import ConfiguracaoService from "@/services/ConfiguracaoService";

export const configuracao = {
  namespaced: true,
  state: {
    configuracao: {},
  },
  actions: {
    getConfiguracao({ commit }, payload) {
      return ConfiguracaoService.GetConfiguracao(payload).then(
        (configuracao) => {
          return Promise.resolve(configuracao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postConfiguracao({ commit }, payload) {
      return ConfiguracaoService.PostConfiguracao(payload).then(
        (configuracao) => {
          return Promise.resolve(configuracao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putConfiguracao({ commit }, payload) {
      return ConfiguracaoService.PutConfiguracao(payload).then(
        (configuracao) => {
          return Promise.resolve(configuracao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteConfiguracao({ commit }, payload) {
      return ConfiguracaoService.DeleteConfiguracao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getConfiguracaoOData({ commit }, payload) {
      return ConfiguracaoService.GetConfiguracaoOData(payload).then(
        (configuracao) => {
          return Promise.resolve(configuracao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default configuracao;
